import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import API from '../config';
import { Helmet } from 'react-helmet-async';
import AddPhoneModal from '../components/AddPhoneModal';
const Step = ({ n, current, T }) => (
  <div style={{ display: 'flex', alignItems: 'center', flex: n < 3 ? 1 : 'none' }}>
    <div style={{
      width: 36, height: 36, borderRadius: '50%', flexShrink: 0,
      background: current >= n ? T.accent : T.surfaceHi,
      border: `2px solid ${current >= n ? T.accent : T.border}`,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      color: current >= n ? '#fff' : T.textDim, fontWeight: 800, fontSize: 14,
      transition: 'all 0.3s',
    }}>
      {current > n ? '✓' : n}
    </div>
    {n < 3 && <div style={{ flex: 1, height: 2, background: current > n ? T.accent : T.border, margin: '0 8px', transition: 'background 0.3s' }} />}
  </div>
);

export default function Deposit() {
  const [amount, setAmount]                   = useState('');
  const [step, setStep]                       = useState(1);
  const [loading, setLoading]                 = useState(false);
  const [error, setError]                     = useState('');
  const [polling, setPolling]                 = useState(false);
  const [pollMsg, setPollMsg]                 = useState('');
  const [checkoutRequestId, setCheckoutRequestId] = useState('');
  const { token }  = useAuth();
  const { T }      = useTheme();
  const navigate   = useNavigate();
  const [phone, setPhone]           = useState(null);
const [showPhoneModal, setShowPhoneModal] = useState(false);


  const quickAmounts = [100, 500, 1000, 2500, 5000, 10000];

  // ── Poll for STK Push confirmation ─────────────────────────────────────────
  useEffect(() => {
    if (!polling || !checkoutRequestId) return;

    const interval = setInterval(async () => {
      try {
        const res = await axios.get(
          `${API}/api/mpesa/status/${checkoutRequestId}`,
          { headers: { Authorization: `Bearer ${token}` } },
        );
        if (res.data.status === 'completed') {
          setPolling(false);
          setPollMsg('✅ Payment confirmed! Your balance has been updated.');
          clearInterval(interval);
          setStep(4);
        } else if (res.data.status === 'failed') {
          setPolling(false);
          setPollMsg('❌ Payment failed or cancelled. Please try again.');
          clearInterval(interval);
          setStep(2);
        }
      } catch (_) {}
    }, 3000);

    const timeout = setTimeout(() => {
      setPolling(false);
      clearInterval(interval);
      setPollMsg('⏳ Taking longer than usual. Check your M-Pesa messages.');
    }, 120000);

    return () => { clearInterval(interval); clearTimeout(timeout); };
  }, [polling, checkoutRequestId, token]);
  useEffect(() => {
  if (!token) return;
  axios.get(`${API}/api/users/profile`, {
    headers: { Authorization: `Bearer ${token}` }
  }).then(res => {
    setPhone(res.data.phone || null);
  });
}, [token]);

  // ── Initiate STK Push ───────────────────────────────────────────────────────
  const handleDeposit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await axios.post(
        `${API}/api/mpesa/deposit`,
        { amount: parseFloat(amount) },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      setCheckoutRequestId(res.data.checkoutRequestId);
      setStep(3);
      setPolling(true);
      setPollMsg('Waiting for M-Pesa confirmation...');
    } catch (err) {
      setError(err.response?.data?.message || 'Deposit failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%', background: T.surfaceHi, border: `1px solid ${T.border}`,
    borderRadius: 8, padding: '13px 14px', color: T.text, fontSize: 14,
    outline: 'none', boxSizing: 'border-box', fontFamily: "'DM Sans',sans-serif",
    transition: 'border-color 0.2s',
  };

  return (
    <div style={{ minHeight: '100vh', background: T.bg, fontFamily: "'DM Sans','Segoe UI',sans-serif", color: T.text }}>
      <Helmet>
  <meta name="robots" content="noindex, nofollow" />
</Helmet>
      <style>{`
        @keyframes fadeUp { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes popIn  { from { opacity: 0; transform: scale(0.8); } to { opacity: 1; transform: scale(1); } }
        * { box-sizing: border-box; margin: 0; padding: 0; }
        input:focus { border-color: ${T.accent} !important; box-shadow: 0 0 0 3px ${T.accent}15; }
        input[type=number]::-webkit-inner-spin-button { -webkit-appearance: none; }
      `}</style>

      {/* Nav */}
      <nav style={{ background: `${T.bg}f2`, backdropFilter: 'blur(16px)', borderBottom: `1px solid ${T.border}`, height: 56, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 24px', position: 'sticky', top: 0, zIndex: 100 }}>
        <div onClick={() => navigate('/markets')} style={{ cursor: 'pointer' }}>
          <svg width="100" height="32" viewBox="0 0 120 38" fill="none">
            <rect x="1" y="1" width="36" height="36" rx="9" fill="#131416" stroke="#2a2b2f" strokeWidth="1.5"/>
            <line x1="11" y1="30" x2="20" y2="8" stroke="#3772ff" strokeWidth="3" strokeLinecap="round"/>
            <line x1="19" y1="30" x2="28" y2="8" stroke="#16c784" strokeWidth="3" strokeLinecap="round"/>
            <text x="46" y="20" dominantBaseline="middle" fontFamily="'DM Sans',sans-serif" fontWeight="800" fontSize="22" fill={T.text} letterSpacing="-1">mino</text>
          </svg>
        </div>
        <button onClick={() => navigate('/dashboard')} style={{ background: 'transparent', color: T.textMuted, border: `1px solid ${T.border}`, borderRadius: 7, padding: '6px 14px', cursor: 'pointer', fontSize: 13 }}>← Dashboard</button>
      </nav>

      <div style={{ maxWidth: 480, margin: '0 auto', padding: '48px 24px', animation: 'fadeUp 0.4s ease' }}>

        {/* Step indicator */}
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 48 }}>
          <Step n={1} current={step} T={T} />
          <Step n={2} current={step} T={T} />
          <Step n={3} current={step} T={T} />
        </div>

        {/* Step 1 — Amount */}
        {step === 1 && (
          <div>
            <h2 style={{ fontSize: 26, fontWeight: 800, letterSpacing: '-0.5px', marginBottom: 6 }}>Add Funds</h2>
            <p style={{ color: T.textMuted, marginBottom: 32, fontSize: 14 }}>Choose how much to deposit via M-Pesa</p>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8, marginBottom: 20 }}>
              {quickAmounts.map(a => (
                <button key={a} onClick={() => setAmount(a.toString())} style={{
                  padding: '14px 8px', borderRadius: 8,
                  border: `1px solid ${amount === a.toString() ? T.accent : T.border}`,
                  background: amount === a.toString() ? `${T.accent}15` : T.surfaceHi,
                  color: amount === a.toString() ? T.accent : T.textMuted,
                  fontWeight: 700, cursor: 'pointer', fontSize: 13,
                  fontFamily: "'DM Mono',monospace", transition: 'all 0.15s',
                }}>
                  KES {a.toLocaleString()}
                </button>
              ))}
            </div>

            <div style={{ marginBottom: 24 }}>
              <label style={{ color: T.textDim, fontSize: 11, display: 'block', marginBottom: 6, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Custom Amount</label>
              <input type="number" value={amount} onChange={e => setAmount(e.target.value)}
                placeholder="Enter amount in KES" min="30" style={inputStyle} />
            </div>

            <button onClick={() => { if (amount) { if (!phone) { setShowPhoneModal(true); return; } setStep(2); } }} disabled={!amount} style={{
              width: '100%', background: amount ? T.accent : T.surfaceHi,
              color: amount ? '#fff' : T.textDim, border: 'none',
              borderRadius: 8, padding: 14, fontSize: 14, fontWeight: 700,
              cursor: amount ? 'pointer' : 'not-allowed', transition: 'all 0.2s',
            }}>
              Continue →
            </button>
          </div>
        )}

        {/* Step 2 — Confirm */}
        {step === 2 && (
          <div>
            <h2 style={{ fontSize: 26, fontWeight: 800, letterSpacing: '-0.5px', marginBottom: 6 }}>Confirm Payment</h2>
            <p style={{ color: T.textMuted, marginBottom: 28, fontSize: 14 }}>An M-Pesa prompt will be sent to your phone</p>

            <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, padding: '18px 20px', marginBottom: 24 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ color: T.textMuted, fontSize: 13 }}>Amount to deposit</span>
                <span style={{ color: T.yes, fontWeight: 800, fontSize: 24, fontFamily: "'DM Mono',monospace" }}>
                  KES {parseFloat(amount).toLocaleString()}
                </span>
              </div>
            </div>

            {/* M-Pesa instructions */}
            <div style={{ background: T.surfaceHi, border: `1px solid ${T.border}`, borderRadius: 8, padding: '14px 16px', marginBottom: 24 }}>
              <p style={{ fontSize: 13, color: T.textMuted, marginBottom: 8, fontWeight: 600 }}>How it works:</p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {[
                  '1. Click Pay below',
                  '2. An M-Pesa prompt appears on your phone',
                  '3. Enter your M-Pesa PIN to confirm',
                  '4. Your Mino balance updates automatically',
                ].map(s => (
                  <p key={s} style={{ fontSize: 13, color: T.textMuted }}>{s}</p>
                ))}
              </div>
            </div>

            {error && (
              <div style={{ background: `${T.no}12`, border: `1px solid ${T.no}33`, color: T.no, padding: '12px 14px', borderRadius: 8, marginBottom: 20, fontSize: 13 }}>
                {error}
              </div>
            )}

            <form onSubmit={handleDeposit}>
              <button type="submit" disabled={loading} style={{
                width: '100%', background: loading ? T.surfaceHi : T.yes,
                color: loading ? T.textDim : '#0f1011', border: 'none',
                borderRadius: 8, padding: 14, fontSize: 14, fontWeight: 700,
                cursor: loading ? 'not-allowed' : 'pointer', marginBottom: 10, transition: 'all 0.2s',
              }}>
                {loading ? 'Sending prompt...' : '📱 Pay via M-Pesa'}
              </button>
              <button type="button" onClick={() => { setStep(1); setError(''); }} style={{ width: '100%', background: 'transparent', color: T.textMuted, border: `1px solid ${T.border}`, borderRadius: 8, padding: 13, cursor: 'pointer', fontSize: 13 }}>
                ← Back
              </button>
            </form>
          </div>
        )}

        {/* Step 3 — Waiting for M-Pesa */}
        {step === 3 && (
          <div style={{ textAlign: 'center', animation: 'popIn 0.4s ease' }}>
            <div style={{ width: 80, height: 80, background: `${T.yes}15`, border: `2px solid ${T.yes}44`, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 36, margin: '0 auto 28px' }}>📱</div>
            <h2 style={{ fontSize: 26, fontWeight: 800, marginBottom: 10 }}>Check Your Phone</h2>
            <p style={{ color: T.textMuted, marginBottom: 8, fontSize: 14 }}>Enter your M-Pesa PIN on the prompt sent to your phone.</p>
            {polling && (
              <p style={{ color: T.accent, fontSize: 13, marginBottom: 8, fontFamily: "'DM Mono',monospace" }}>
                ⏳ Waiting for confirmation...
              </p>
            )}
            {pollMsg && !polling && (
              <p style={{ color: pollMsg.startsWith('✅') ? T.yes : T.no, fontSize: 14, fontWeight: 700, marginBottom: 8 }}>
                {pollMsg}
              </p>
            )}
            <p style={{ color: T.textDim, fontSize: 13, marginBottom: 40, fontFamily: "'DM Mono',monospace" }}>
              KES {parseFloat(amount).toLocaleString()} will be added once confirmed.
            </p>
            <button onClick={() => navigate('/dashboard')} style={{ background: T.accent, color: '#fff', border: 'none', borderRadius: 8, padding: '14px 40px', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>
              Go to Dashboard →
            </button>
          </div>
        )}

        {/* Step 4 — Confirmed */}
        {step === 4 && (
          <div style={{ textAlign: 'center', animation: 'popIn 0.4s ease' }}>
            <div style={{ width: 80, height: 80, background: `${T.yes}15`, border: `2px solid ${T.yes}44`, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 36, margin: '0 auto 28px' }}>✅</div>
            <h2 style={{ fontSize: 26, fontWeight: 800, marginBottom: 10 }}>Payment Confirmed!</h2>
            <p style={{ color: T.textMuted, marginBottom: 8, fontSize: 14 }}>
              KES {parseFloat(amount).toLocaleString()} has been added to your balance.
            </p>
            <button onClick={() => navigate('/dashboard')} style={{ background: T.yes, color: '#fff', border: 'none', borderRadius: 8, padding: '14px 40px', fontSize: 14, fontWeight: 700, cursor: 'pointer', marginTop: 32 }}>
              Go to Dashboard →
            </button>
          </div>
        )}

      </div>
      {showPhoneModal && (
        <AddPhoneModal
          onSuccess={(savedPhone) => {
            setPhone(savedPhone);
            setShowPhoneModal(false);
            setStep(2);
          }}
          onClose={() => setShowPhoneModal(false)}
        />
      )}
  </div>
  );
}